'use client';

/**
 * Cross-cutting "is any recording active" flag, read by AuthProvider to suppress
 * SIGNED_OUT-triggered reloads and visibility-resync redirects that would abort
 * an in-progress recording. It lives in @kit/shared (not next to a single
 * recorder) so every recorder — the agents voice-dictation hook in apps/web AND
 * the meetings/KB hook in @kit/meetings — writes the SAME module-level singleton
 * that AuthProvider reads. A second copy of this module would be a second
 * singleton, and the guard would silently no-op for whichever recorder didn't
 * own the instance AuthProvider imports.
 */
let recordingActive = false;

export function setRecordingActive(active: boolean) {
  recordingActive = active;
}

export function isRecordingActive() {
  return recordingActive;
}
